// extracted by mini-css-extract-plugin
export default {"container":"SessionAgenda_container__3xtWM","heading":"SessionAgenda_heading__LWKJZ"};